module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon11b.d8cf53c3.png";